import React, { useEffect, useState } from 'react';
import './App.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Home from './Pages/Home';
import Postos from './Pages/Postos';
import Graficos from './Pages/Graficos';
import InserirRegistro from './Pages/InserirRegistro';
import ConsultarRegistro from './Pages/ConsultarRegistro';
import HEHE from './Pages/Previsao';

import { Routes, Route, Navigate } from "react-router-dom";
import Login from './Pages/Login';
import MapaDetalhado from './Pages/MapaDetalhado';
import MapaComposto from './Pages/MapaComposto';
import Previsao from './Pages/Previsao';

const App = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<string>('');

  const setAuth = (bool: boolean) => {
    setIsAuthenticated(bool);
  };

  const isAuth = async () => {
    try {
      const response = await fetch(`${apiUrl}/auth/is-verify/`, {
        method: "GET",
        headers: { token: localStorage.token }
      });
      const parseRes = await response.json();
      parseRes === true ? setIsAuthenticated(true) : setIsAuthenticated(false);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    isAuth();
  }, []);

  useEffect(() => {
  }, [currentPage]);

  return (
    <>
      <ToastContainer />
      <Navbar setAuth={setAuth} isAuthenticated={isAuthenticated} currentPage={currentPage} />

      <div className="css-app-min-height-90">
        <Routes>
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/home" element={<Home setCurrentPage={setCurrentPage} />} />
          <Route path="/inserir-registro" element={isAuthenticated ? <InserirRegistro setCurrentPage={setCurrentPage} /> : <Login setAuth={setAuth} setCurrentPage={setCurrentPage} />} />
          <Route path="/consultar-registro" element={<ConsultarRegistro setCurrentPage={setCurrentPage} />} />
          <Route path="/postos" element={<Postos setCurrentPage={setCurrentPage} isAuthenticated={isAuthenticated} />} />
          <Route path="/graficos" element={<Graficos setCurrentPage={setCurrentPage} />} />
          <Route path="/mapa-composto" element={<MapaComposto setCurrentPage={setCurrentPage} />} />
          <Route path="/mapa-detalhado" element={<MapaDetalhado setCurrentPage={setCurrentPage} />} />
          <Route path="/previsao" element={<Previsao setCurrentPage={setCurrentPage} />} />
          <Route path="/login" element={isAuthenticated ? <Home setCurrentPage={setCurrentPage} /> : <Login setAuth={setAuth} setCurrentPage={setCurrentPage} />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
};

export default App;